var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgRocketOff = function SvgRocketOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Rocket_off_svg__Rocket_off_svg__clip0_7288_47844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.742 7.728c-.09.198-.17.4-.242.604a5 5 0 00-4.167 2.5 6.667 6.667 0 015.834 5.833 5 5 0 002.5-4.166c.2-.071.398-.15.59-.236m2.023-1.342a7.5 7.5 0 002.387-5.089 2.5 2.5 0 00-2.5-2.5 7.5 7.5 0 00-5.09 2.387",
    stroke: "#48525C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.833 11.668a5 5 0 00-2.5 5 5 5 0 005-2.5m3.333-6.667a.833.833 0 101.667 0 .833.833 0 00-1.667 0zM2.5 2.5l15 15",
    stroke: "#48525C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Rocket_off_svg__Rocket_off_svg__clip0_7288_47844"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgRocketOff;